module.exports = __webpack_public_path__ + "img/choose_img2.2ae7f86e.png";